query GetTrainingCourses($categoryId: ID) {
  trainingCourses(categoryId: $categoryId) {
    id
    title
    slug
    controlReference
    status
    position
    category {
      id
      name
    }
    requirement
    audience
    audienceCount
    publishedModuleCount
    updatedAt
    modules {
      id
    }
  }
}
